export default "__VITE_ASSET__rUDLOSQL__"